import { getConfig } from '@sydle/ui-utils';
import type { UIApiConfig } from '@sydle/ui-api';

export function getBaseUrl(): string {
  return getConfig<UIApiConfig>('ui-api')?.BASE_API_URL || '';
}

export function getApplicationName(): string {
  return getConfig<UIApiConfig>('ui-api')?.APPLICATION_IDENTIFIER || '';
}

export function getFacadeUrl(): string {
  return `${getBaseUrl()}${getApplicationName()}/com.sydle.growth.marketing/siteFacadeSYDLE`;
}
